import React, { useEffect, useState } from "react";
import { Range, DateRangePicker, RangeKeyDict } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch, useSelector } from "react-redux";
import { setVehicle } from "../../redux/slices/addVehicleSlice";
import { enUS } from "date-fns/locale";
import { getDatesInRange } from "../../utils/daysBetweenDates";
import { RootState } from "../../redux/store";
import { AddVehicleType } from "../../types";

const SelectDates: React.FC = () => {
  const vehicle: AddVehicleType[] = useSelector(
    (state: RootState) => state.addVehicle.Vehicle
  );

  const [regDate, setRegDate] = useState<Date>();
  const [maxDate, setMaxDate] = useState<Date>(new Date());

  const [state, setState] = useState<Range[]>([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [availability, setAvailability] = useState<
    {
      startDate: Date;
      endDate: Date;
    }[]
  >([]);
  const [calendarDirection, setCalendarDirection] = React.useState<
    "horizontal" | "vertical"
  >("horizontal");

  const [alwaysAvailable, setAlwaysAvailable] = React.useState<boolean>(false);

  const [dateRange, setDateRange] = React.useState<boolean>(true);

  const handleSelect = () => {
    setAlwaysAvailable(!alwaysAvailable);
    setDateRange(!dateRange);
  };

  const dispatch = useDispatch();

  // const handleRangeSelect = (item: RangeKeyDict) => {
  //   // console.log(item.selection);
  //   // console.log(state);

  //   // // const state = state;

  //   // if (!state[0].endDate) {
  //   //   state[0].endDate = item.selection.endDate;
  //   //   state[0].startDate = item.selection.startDate;
  //   //   return;
  //   // }

  //   // if (state.length) {
  //   //   state.forEach((option, index) => {
  //   //     if (
  //   //       option.startDate === item.selection.startDate ||
  //   //       option.startDate === item.selection.endDate ||
  //   //       option.endDate === item.selection.startDate ||
  //   //       option.endDate === item.selection.endDate
  //   //     ) {
  //   //       // state.splice(index, 1);
  //   //       // state[index] = item.selection;
  //   //       option.startDate = item.selection.startDate;
  //   //       option.endDate = item.selection.endDate;
  //   //       return;
  //   //     } else {
  //   //       state.push(item.selection);
  //   //       return;
  //   //     }
  //   //   });
  //   // }

  //   setState([item.selection]);
  //   setAvailability([...availability, {startDate: item.selection.startDate!, endDate: item.selection.endDate!}])
  // };

  const handleRangeSelect = async (item: RangeKeyDict) => {
    // console.log("selection", item.selection);
    if (item.selection) {
      try {
        // console.log("selection", item.selection);
        // const dates = `${item.selection.startDate.toISOString()},${item.selection.endDate.toISOString()}`;
        // console.log(dates);

        const arr = getDatesInRange(
          item.selection.startDate!,
          item.selection.endDate!
        );

        // console.log(arr);

        dispatch(setVehicle({ availability: arr }));

        setState([item.selection]);
      } catch (error) {
        console.log(error);
      }
    }
  };

  function generateOneYearDatesArray() {
    let dateArray = [];
    let currentDate = new Date();

    for (let i = 0; i <= 365; i++) {
      dateArray.push(new Date(currentDate).toISOString());
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateArray;
  }

  // useEffect(() => {
  //   if (alwaysAvailable) {
  //     dispatch(setVehicle({ availability: generateOneYearDatesArray() }));
  //   }
  // }, [alwaysAvailable]);

  useEffect(() => {
    if (window.innerWidth < 780) {
      setCalendarDirection("vertical");
      return;
    } else if (window.innerWidth > 780 && calendarDirection !== "horizontal") {
      setCalendarDirection("horizontal");
      return;
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (vehicle[0].registrationInfo?.length) {
      const [year, month] = vehicle[0].registrationInfo?.split("-").map(Number);
      // Set the date to the first day of the next month, then subtract one day to get the last day of the current month
      const lastDayOfMonth = new Date(year, month, 0);
      setRegDate(lastDayOfMonth);
    }
  }, [vehicle[0].registrationInfo]);

  useEffect(() => {
    const insuranceMaxDate = new Date(
      vehicle[0]?.insuranceExpDate ?? new Date().toISOString()
    );

    const regMaxDate = new Date((regDate as Date) ?? new Date().toISOString());

    setMaxDate(
      new Date(Math.max(insuranceMaxDate.getTime(), regMaxDate.getTime()))
    );
  }, [vehicle[0]?.insuranceExpDate, regDate]);

  return (
    <>
      <div className="flex w-[80%] lg:w-[70%] py-10 border rounded-2xl mx-auto justify-center  h-full  flex-col gap-4 lg:items-center  bg-white">
        <p className=" text-black text-center font-Poppins font-semibold lg:font-medium text-[25px] lg:text-[40px]  ">
          Set Vehicle Availability
        </p>
        {/* <ul className="w-[90%] mx-auto  list-outside  list-disc  ">
          <li className=" flex justify-between items-center w-full font-Poppins text-black text-[14px] lg:text-[24px] font-bold   ">
            Vehicle is always available{" "}
            {alwaysAvailable === true ? (
              <img
                src={Yes}
                alt=""
                className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                onClick={() => handleSelect()}
              />
            ) : (
              <img
                src={No}
                alt=""
                className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                onClick={() => handleSelect()}
              />
            )}
          </li>
          <li className=" flex justify-between items-center w-full  font-Poppins text-black text-[14px] lg:text-[24px] font-bold  ">
            Vehicle is available for a date range{" "}
            {dateRange ? (
              <img
                src={Yes}
                alt=""
                className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                onClick={() => handleSelect()}
              />
            ) : (
              <img
                src={No}
                alt=""
                className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                onClick={() => handleSelect()}
              />
            )}
          </li>
        </ul> */}
        {dateRange && (
          <div className="flex flex-col  gap-5 w-full  mx-auto  lg:w-2/3 ">
            {/* <h3 className="font-Poppins text-midGreen flex flex-col text-[24px] font-medium text-center ">
              Selected Dates{" "}
              <span className="text-darkGreen">
                {`${format(dates.startDate, "MM/dd/yyyy")} to ${format(
                  dates.endDate,
                  "MM/dd/yyyy"
                )}`}{" "}
              </span>
            </h3> */}

            <DateRangePicker
              onChange={(item) => handleRangeSelect(item)}
              // showSelectionPreview={false}
              moveRangeOnFirstSelection={false}
              editableDateInputs={true}
              months={2}
              ranges={state}
              locale={enUS}
              preview={undefined}
              showPreview={false}
              rangeColors={["#215759"]}
              color="#215759"
              direction={calendarDirection}
              staticRanges={undefined}
              inputRanges={undefined}
              minDate={new Date()}
              maxDate={maxDate}
              className="w-full flex justify-center flex-wrap"
            />

            {/* <DateRange
              editableDateInputs={true}
              showDateDisplay={false}
              onChange={(item) => handleRangeSelect(item)}
              moveRangeOnFirstSelection={false}
              months={3}
              direction="vertical"
              ranges={[dates]}
              minDate={new Date()}
              locale={enUS}
              className="w-full flex flex-col gap-4 flex-wrap justify-center items-center overflow-hidden"
            /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default SelectDates;
